export interface IFileUploadRequest {
    ano: number;
    ono: number;
    vno: number;
    container_tag: string;
}
